export const validateBasicDetailsForm = (formData) => {
    const errors = [];
    let isValid = true;
  
    if (!formData.rentalType || formData.rentalType === "") {
      errors.push({
        error: "Rental type is required",
        errorType: 'rentalType'
      });
      isValid = false;
    }
  
    if (!formData.accomodationCapacity || formData.accomodationCapacity === "") {
      errors.push({
        error: "Accommodation capacity is required",
        errorType: 'accomodationCapacity'
      });
      isValid = false;
    }
  
    if (!formData.propertyType || formData.propertyType === "") {
      errors.push({
        error: "Property type is required",
        errorType: 'propertyType'
      });
      isValid = false;
    }
  
    if (!formData.bookingType || formData.bookingType === "") {
      errors.push({
        error: "Booking type is required",
        errorType: 'bookingType'
      });
      isValid = false;
    }
  
    if (!formData.covidVerified || formData.covidVerified === "") {
      errors.push({
        error: "COVID vaccination requirement is required",
        errorType: 'covidVerified'
      });
      isValid = false;
    }
  
    if (!formData.address || formData.address === "") {
      errors.push({
        error: "Address is required",
        errorType: 'address'
      });
      isValid = false;
    }
  
    if (!formData.location) {
      errors.push({
        error: "Location is required",
        errorType: 'location'
      });
      isValid = false;
    }
  
    if (formData.accomodationCapacity) {
      const capacity = parseInt(formData.accomodationCapacity);
      if (isNaN(capacity) || capacity <= 0) {
        errors.push({
          error: "Accommodation capacity must be greater than 0",
          errorType: 'accomodationCapacity'
        });
        isValid = false;
      }
    }
  
    if (formData.bookingType === "Cold bed" || formData.bookingType === "Flexible") {
      if (!formData.reservedDays || formData.reservedDays === "") {
        errors.push({
          error: "Reserve stay limit is required for this booking type",
          errorType: 'reservedDays'
        });
        isValid = false;
      }
      
      if (!formData.lineholderDays || formData.lineholderDays === "") {
        errors.push({
          error: "Lineholder stay limit is required for this booking type",
          errorType: 'lineholderDays'
        });
        isValid = false;
      }
    }
  
    if (formData.location) {
      if (!formData.location.lat || !formData.location.lng) {
        errors.push({
          error: "Invalid location coordinates",
          errorType: 'location'
        });
        isValid = false;
      }
    }
  
    return {
      isValid,
      errors,
    };
  };
  